
import {
    StepperDropdownContainer,
    StepperDropdownContent,
    StepperDropdownHeader,
    StepperDropdownHeaderIcon,
    StepperDropdownHeaderTitle
} from '../../dropdown/StepperDropdown'
import { StepCompletedSvg } from '../../../../../CommonComponents/svgs/Svgs'
import { FC } from 'react'
import { StepperProps } from '../../../utils/stepper-types'


const GeoFeatures: FC<StepperProps> = ({ title, hideComponent, open, disabled, stepCompleted, onToggle }) => {
    if (hideComponent) return null
    return (
        <StepperDropdownContainer
            open={open}
            disabled={disabled}
        >
            <StepperDropdownHeader
                title={title}
                onToggle={onToggle}
            >
                <StepperDropdownHeaderTitle>
                    {title}
                </StepperDropdownHeaderTitle>
                <StepperDropdownHeaderIcon show={stepCompleted}>
                    <StepCompletedSvg />
                </StepperDropdownHeaderIcon>
            </StepperDropdownHeader>
            <StepperDropdownContent>
                Details Content
            </StepperDropdownContent>
        </StepperDropdownContainer>
    )
}

export default GeoFeatures